var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teams"},[_c('h5',{staticClass:"chat-headings"},[_vm._v("Utilisateurs "),_c('span',[_vm._v("Online "+_vm._s(_vm.filterOnlineUsers.length))])]),_c('div',{staticClass:"team-container"},_vm._l((_vm.filterOnlineUsers),function(u){return _c('online-user',{key:u,attrs:{"user-uid":u}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }